export const Star = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 0c1.3 6.9 5.1 10.7 12 12-6.9 1.3-10.7 5.1-12 12-1.3-6.9-5.1-10.7-12-12C6.9 10.7 10.7 6.9 12 0Z" />
  </svg>
);

export const Squiggle = ({ className = "" }) => (
  <svg viewBox="0 0 120 20" fill="none" className={className} aria-hidden="true">
    <path
      d="M3 13c9-9 15 7 24 0s15 7 24 0 15 7 24 0 15 7 24 0 12 5 18 2"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export const Dot = ({ className = "" }) => (
  <svg viewBox="0 0 12 12" fill="currentColor" className={className} aria-hidden="true">
    <circle cx="6" cy="6" r="6" />
  </svg>
);

export const Blob = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" fill="currentColor" className={className} aria-hidden="true">
    <path d="M21 3c7 0 13 4 15 10 2 7 0 13-5 17-6 4-14 4-19 0C6 26 4 17 8 11 11 6 15 3 21 3Z" />
  </svg>
);

export const Spiral = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <path
      d="M20 6c8 0 14 6 14 14s-6 14-14 14S8 28 8 20c0-6 5-11 11-11 5 0 9 4 9 9s-4 8-8 8-7-3-7-7 3-6 6-6"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);
